import * as images from "./images";

export const special = [
  // {
  //   img: images.corto,
  //   nome: {
  //     it: "Negroni al Tartufo",
  //     en: "Truffle Negroni",
  //   },
  //   ricetta: {
  //     it: "Gin, tartufo, bitter, fine tawny port, whisky",
  //     en: "Gin, truffle, bitter, fine tawny port, whisky ",
  //   },
  // },
  {
    img: images.sakura,
    nome: {
      it: "Sakura",
      en: "Sakura",
    },
    ricetta: {
      it: "Ki no bi Gin, Sakura Vermouth, Sake Honjozo Tokubetsu",
      en: "Ki no bi Gin, Sakura Vermouth, Sake Honjozo Tokubetsu",
    },
  },
  {
    img: images.lowball,
    nome: {
      it: "Golden Mex",
      en: "Golden Mex",
    },
    ricetta: {
      it: "Edible gold, Casamigos blanco Tequila, Grand Classico",
      en: "Bitter, Antica Formula Vermouth",
    },
  },
];
